/**
 * Created by Tomasz Gabrysiak @ Infermedica on 06/03/2017.
 *
 * Please provide your own app-id and app-key below.
 * To obtain keys please register at https://developer.infermedica.com.
 */

const settings = {
  'app-id': 'c396a6a6',
  'app-key': 'f1be18bc04a3849307855f63dfb39a64'
};

export default settings;



// WEBPACK FOOTER //
// ./src/settings.js